var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{class:[
    _vm.className,
    (_vm.className + "--" + _vm.type)
  ],style:(_vm.styleObject),attrs:{"data-test":_vm.className}},[_vm._t("default"),(_vm.closeable)?_c('span',{class:_vm.btClassName,attrs:{"data-test":_vm.btClassName},on:{"click":_vm.onClose}},[_vm._v(" × ")]):_vm._e()],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }